import React, { useEffect, useState } from 'react';
import LanguagePopup from './profile/profileEditPage/LanguagePopup';
import { getLanguages, saveProfile } from '../Api/api';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import SettingOption from './profile/components/settingOption';
import { useDispatch, useSelector } from 'react-redux';
import { setEditedProfile } from '../redux/applicationSlice';
import ProfileEditDone from './profile/profileEditPage/profileEditDone';
import { utility } from '../utility/utility';
import { LOCAL_STORAGE_KEY } from '../constant';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
    const navigate = useNavigate();
    const [showLanguageSelector, setShowLanguageSelector] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    const { ref, focusKey, focusSelf, setFocus } = useFocusable({
        focusKey: "settings-page",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
    });

    const { user, logo, theme, profiles, selectedProfile, editedProfile, ottSettings, dialog } = useSelector((state) => state.application);

    const dispatch = useDispatch();

    useEffect(() => {
        if (showLanguageSelector || dialog.show) return;
        setTimeout(() => {
            focusSelf();
        }, 100);
    }, [showLanguageSelector, dialog.show]);

    const showLanguageSelectorPopup = async () => {
        let res = await getLanguages();
        if (res.success) {
            setLanguages(res.data);
            setShowLanguageSelector(true);
        } else {
            console.log(res);
            setShowLanguageSelector(false);
        }
    }

    const onSave = async () => {
        if (isSaving) { return; }
        setIsSaving(true);
        console.log(editedProfile);
        utility.setValue(LOCAL_STORAGE_KEY.language, editedProfile?.Language ?? null);
        let saveResponse = await saveProfile(editedProfile);
        setIsSaving(false);
        if (!saveResponse.success) {
            //error message
        } else {
            dispatch(setEditedProfile(saveResponse.data));
        }
        navigate('/');
    }

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} style={{
                display: 'flex', alignItems: 'center', height: '100vh', backgroundColor: theme?.general?.bgColor ?? "#000000", color: theme?.general?.color ?? "#828282", paddingTop: "20px", flexDirection: "column",
                filter: `blur(${!(showLanguageSelector) ? "0px" : "5px"})`, pointerEvents: `${(showLanguageSelector) ? "none" : "auto"}`,
            }}>
                <ProfileEditDone onSave={onSave} isSaving={isSaving} setFocuTo={"setting-option-Language"} />
                <span style={{ fontSize: "24px", marginBottom: "20px", fontWeight: "bold" }}>{"Settings"}</span>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <SettingOption height={"60px"} width={"400px"} title={"Language"} description={editedProfile?.Language ? (editedProfile?.Language?.Description ?? "English") : "English"} icon={'globe'} iconColor={"#007FFF"} showToggle={false} onClick={showLanguageSelectorPopup} />
                    <SettingOption height={"60px"} width={"400px"} title={"Autoplay Next Episode"} icon={'tv'} iconColor={"red"} toggleValue={editedProfile?.AutoplayNextEpisode} onClick={() => {
                        dispatch(setEditedProfile({ ...editedProfile, AutoplayNextEpisode: !editedProfile?.AutoplayNextEpisode }))
                    }} canMoveDown={false} />
                </div>
            </div>
            <LanguagePopup languages={languages} languageSelector={showLanguageSelector} setLanguageSelector={setShowLanguageSelector} />
        </FocusContext.Provider>
    );
}

export default Settings;
